import { render, staticRenderFns } from "./DiagnosticDocumentsModal.vue?vue&type=template&id=6335b3e1&scoped=true"
import script from "./DiagnosticDocumentsModal.vue?vue&type=script&lang=js"
export * from "./DiagnosticDocumentsModal.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticDocumentsModal.vue?vue&type=style&index=0&id=6335b3e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6335b3e1",
  null
  
)

export default component.exports